import {useRef} from 'react';
import QRCode from 'qrcode.react';
import {useRouter} from 'next/router';
import {existWindow} from '@src/utils/common';
import {getValidPath} from '@src/utils/route';
import {useRecoilState} from 'recoil';
import {qrPopupState} from '@src/store';
import useClickOutside from '@src/hooks/useClickOutside';

function QRpopup () {
  const router = useRouter();
  const {url} = router.query;
  const [qrType, setQRType] = useRecoilState(qrPopupState);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setQRType(''));

  if (qrType === '') {
    return <></>;
  }

  return (
    <div className="popup_layer popup_qrcode">
      <div className="inner_layer" ref={ref}>
        <div className="layer_head">
          {' '}
          <strong className="tit_layer">카카오구독ON</strong>
        </div>
        <div className="layer_body">
          {existWindow() && <QRCode className="img_qrcode" value={`${location.origin}${getValidPath(url + qrType)}`} />}
          <p className="desc_layer">
            카카오구독ON은
            <br />
            모바일에서 이용가능합니다.
            <br />
            스마트폰으로 위 QR코드를
            <br />
            찍어 확인해주세요.
          </p>
        </div>
      </div>
    </div>
  );
}

export default QRpopup;
